import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  newSubsectionButton: {
    id: 'course-authoring.course-outline.section.button.new-subsection',
    defaultMessage: 'Nowa podsekcja',
  },
  sectionHighlightsBadge: {
    id: 'course-authoring.course-outline.section.badge.section-highlights',
    defaultMessage: 'Najważniejsze informacje w sekcji',
  },
});

export default messages;
